define('controllers/mysetting/corpattation/valid-result.ctrl',['app'], function (app) {
    app.controller('CorpattionValidResult', ['$q', '$scope', '$state', 'UserInfo','$stateParams', '$rootScope','UserInfoPreload',
        function ($q, $scope, $state, UserInfo,$stateParams,$rootScope,UserInfoPreload) {
    	
    	 	var corpResult = $stateParams.corpResult;
            $rootScope.isFromAgc = ($rootScope.isFromAgc || UserInfoPreload.verifyRealState == 2);
            var Model = $scope.Model = {
                resultFlag:{
                	validSuccess:true,
                	validFailhasChoice:false,
                	validFailNoChoice:false
                },
                resultTitle:{
                	validSuccess:'恭喜您通过企业实名认证',
                	validFailhasChoice:'认证失败。',
                	validFailNoChoice:'认证失败。'
                },
                resultMsg:{
                	validSuccess:'',
                	validFailhasChoice:$rootScope.isFromAgc?'您本次银行打款认证输入的打款金额错误次数已达上限，企业实名认证失败。您<br/>可以重新提交银行打款认证。':'您本次银行打款认证输入的打款金额错误次数已达上限，企业实名认证失败。您<br/>可以重新提交银行打款认证，或者选择人工审核认证。',
                	validFailNoChoice:$rootScope.isFromAgc?'您提交的银行打款认证次数已达上限。如有疑问，请联系客服。':'您提交的银行打款认证次数已达上限，请选择人工审核认证并重新提交认证。'
                },
                corpResult:corpResult,
                authUrlCorp: systemParaConf.user.userAuthCorpUrl,
                authUrlCorpAtteion:$rootScope.isFromAgc?systemParaConf.user.userUrl4agc:systemParaConf.user.userCorpatteionrzUrl
                
            };
            Model.userInfo = UserInfo.get();
            Model.resultF = Model.resultFlag[corpResult];
            Model.resultT = Model.resultTitle[corpResult];
            Model.resultMsg = Model.resultMsg[corpResult];
            if($scope.isHarmony){
                Model.authUrlCorpAtteion=systemParaConf.user.userCorpatteionrzUrl+"?type=1&channel=8";
                Model.authUrlCorp= systemParaConf.user.userAuthCorpUrl+"?type=1&channel=8";
            }
            
            init();
            function init(){
            	ucdFlow();
            }
            
            function ucdFlow(){
            	 new UCD.Workflow('#workflow', {
                     spacing:236,
                     steps: [
                       { title: '录入企业资料与银行账户信息', statu: 3 },
                       { title: '输入打款金额', statu: 3 },
                       { title: '完成认证', statu: corpResult =='validSuccess' ? 3 : 2 }
                     ]
                 });
            }
            
            //进商户服务页面
            Model.goMerchant = function() {
                $state.go('mysetting.modBussnessInfo', {},{reload: true});
            };
            
            Model.close = function(){
            	$state.go('mysetting.modUserInfoCorp', {},{reload: true});
            };

        }]);
});

